"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * setCookie
 * @param key {string}  key 문자열.
 * @param value {string} value 문자열.
 * @param days {number} 만료기간. 단위 : 일.
 * @param domain {string} 지정된 도메인에서만 쿠키 접근이 가능하다. 생략하면 모든 도메인에서 접근 가능하다.
 * @param path {string} 지정하지 않으면 현재 문서의 경로(도메인 명 제외)가 지정된다.
 */
var setCookie = function (key, value, days, domain, path) {
    if (days === void 0) { days = 1; }
    var expire = '';
    days && (expire = '; expires=' + new Date(new Date().getTime() + days * 1000 * 60 * 60 * 24).toString());
    var sDomain = domain || '';
    var sPath = path || '/';
    document.cookie =
        key + '=' + encodeURIComponent(value) + expire + '; path=' + sPath + (sDomain ? '; domain=' + sDomain : '');
};
exports.setCookie = setCookie;
//# sourceMappingURL=cookieUtils.js.map